import { createSlice } from "@reduxjs/toolkit";

const initSpaces = {
  mySpaces: [],
  searchSpaces: [],
  venueSpaces: [],
};

const reducers = {
  getSearchSpaces: (state: any, action: any) => {
    const items = action.payload.items;
    const updateList = action.payload.updateList;

    if (updateList) {
      state.searchSpaces = items;
    }

    state.searchSpaces = items;
  },
  getMySpaces: (state: any, action: any) => {
    const items = action.payload.items;

    state.mySpaces = items;
  },
  getVenueSpaces: (state: any, action: any) => {
    const newItems = action.payload.items;
    const updateList = action.payload.updateList;

    if (updateList) {
      state.venueSpaces = newItems;
    } else {
      const existingIds = new Set(
        state.venueSpaces.map((item: { id: string }) => item.id)
      );
      const filteredItems = newItems.filter(
        (item: { id: string }) => !existingIds.has(item.id)
      );

      state.venueSpaces.push(...filteredItems);
    }
  },
  createVenueSpace: (state: any, action: any) => {
    const newSpot = action.payload.item;

    state.venueSpaces.unshift(newSpot);
  },
  updateVenueSpace: (state: any, action: any) => {
    const tempItems = state.venueSpaces;
    const newItem = action.payload.item;

    const index = tempItems.findIndex(
      (item: { id: string }) => item.id === newItem.id
    );

    state.venueSpaces[index] = newItem;
  },
  deleteVenueSpace: (state: any, action: any) => {
    const tempItems = [...state.venueSpaces];
    const itemID = action.payload.id;

    const updatedLlist = tempItems.filter((item) => item.id !== itemID);

    state.venueSpaces = updatedLlist;
  },
};

const SpaceReducers = createSlice({
  name: "spacesReducers",
  initialState: initSpaces,
  reducers,
});

export const {
  getVenueSpaces,
  createVenueSpace,
  updateVenueSpace,
  deleteVenueSpace,
  getSearchSpaces,
  getMySpaces,
} = SpaceReducers.actions;

export default SpaceReducers.reducer;
